import { render } from "./NewOrderCustomer.vue?vue&type=template&id=4621ab54&scoped=true&ts=true"
import script from "./NewOrderCustomer.ts?vue&type=script&lang=ts"
export * from "./NewOrderCustomer.ts?vue&type=script&lang=ts"

import "./NewOrderCustomer.vue?vue&type=style&index=0&id=4621ab54&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4621ab54"]])

export default __exports__